export const paymentModes = {
  weChat: {
    value: 7,
    name: '门店微信账号',
  },
  alipay: {
    value: 8,
    name: '门店支付宝账号',
  },
  fuZhangGui: {
    value: 10,
    name: '门店富掌柜账号',
  },
  meituan: {
    value: 9,
    name: '门店美团账号',
  },
  card: {
    value: 2,
    name: '门店银行账号',
  },
  cash: {
    value: 1,
    name: '现金',
  },
  youZan: {
    value: 3,
    name: '总部有赞账号',
  },
  douYin: {
    value: 6,
    name: '总部抖音账号',
  },
  transfer: {
    value: 5,
    name: '总部银行账号',
  },
  applet: {
    value: 4,
    name: '总部小程序账号',
  },
  xiaoHongShu: {
    value: 11,
    name: '总部小红书账号',
  },
}

export function findPaymentModeName(value) {
  for (const key in paymentModes) {
    if (value === paymentModes[key].value) return paymentModes[key].name;
  }
  return '未记录';
}
